// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t8Qhz","col":"styles_col__35Psn"};